import React, {useEffect, useState} from "react";
import {Col, Container, Form, Row} from "react-bootstrap";
import UserDashboardPageUserMenu from "../@@Parts/@Menu";
import UserDashboardPageContent from "../@@Parts/Content";
import {UserDashboardPageContentSection} from "@Pages/@@UserPages/@Dashboard/@@Parts";
import {ButtonComponent, FormDropdownComponent, InputComponent} from "@Components/Forms";

import dateFormat from "dateformat";

import paypallIcon from "./@Icons/paypall.svg";
import bankIcon from "./@Icons/bank.svg";

import IconPhotoS from "./@Icons/icon-photo-s-black.svg";
import IconKeyS from "./@Icons/icon-key-s-black.svg";
import IconEditS from "./@Icons/icon-edit-s-black.svg";
import IconDollarS from "./@Icons/icon-dollar-s-orange.svg";
import IconChartS from "./@Icons/icon-chart-s-orange.svg";

import UserAvatar from "./@Icons/avatar.png";


import "./index.scss";
import {SvgIconComponent} from "@Components/Elements";
import BadgeElementComponent from "@Components/@Elements/@Badges";
import {DashboardInformationCardElementComponent} from "@Components/@Elements/@Cards";
import {UseQyvoUser} from "@Store/@Hooks";
import {Countries} from "@Pages/JoinQyvo/RegisterForm/countries";
import SystemCommunicateElementComponent from "@Components/@Elements/@Popups/@SystemCommunicate";
import {InputComponentStatusType} from "@Components/Forms/Inputs/Input/types";
import isEmail from "validator/lib/isEmail";
import {isMobilePhone, isMobilePhoneLocales} from "validator";
import {PulseLoader} from "react-spinners";
import ApiRequestLoaderElementComponent from "@Components/@Elements/@Popups/Loaders/ApiRequest";
import UserDashboardUserMenuComponent from "@Pages/@@UserPages/@@Dashboard/@@@Menu";
import {DefaultPopupComponent, InputFieldComponent} from "@Elements";



interface QyvoUserDataInterface {
    qyvo_user_first_name: string;
    qyvo_user_last_name: string;
    qyvo_user_email: string;
    qyvo_user_profile_picture: string | null;
    qyvo_user_registration_date: string;
}

interface QyvoUserAddressDataInterface {
    qyvo_user_address_country?: number;
    qyvo_user_address_street?: string;
    qyvo_user_address_house_no?: string;
    qyvo_user_address_postal_code?: string;
    qyvo_user_address_city?: string;
    qyvo_user_address_phone_number?: string;
}


export const UserDashboardProfilePage:React.FC = () => {

    const QyvoUser = UseQyvoUser();

    const [QyvoUserData, setQyvoUserData] = useState<QyvoUserDataInterface | null>(null);
    const [QyvoUserAddressData, setQyvoUserAddressData] = useState<QyvoUserAddressDataInterface | null>(null);

    const [QyvoUserInformationUpdateTrigger, setQyvoUserInformationUpdateTrigger] = useState(false);

    const [QyvoUserEditDataStatus, setQyvoUserEditDataStatus] = useState(false);

    const [systemCommunicateMessage, setSystemCommunicateMessage] = useState('');
    const [restApiRequestPendingStatus, setRestApiRequestPendingStatus] = useState(false);

    useEffect(() => {

        if (QyvoUserData && !QyvoUserInformationUpdateTrigger) {
            return;
        } else {
            setQyvoUserInformationUpdateTrigger(false);
        }

        const getQyvoUserData = async () => {
            try {
                const response = await fetch(
                    `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-user-by-email/?user_email=${QyvoUser?.qyvoUserEmail}&user_data=true`
                );
                if (response.ok) {
                    const responseData = await response.json();
                    setQyvoUserData(responseData);
                }
            } catch (e) {
                console.error(e);
            }
        };
        getQyvoUserData();
    }, [QyvoUser, QyvoUserInformationUpdateTrigger]);

    useEffect(() => {

        if (QyvoUserAddressData && !QyvoUserInformationUpdateTrigger) {
            return;
        } else {
            setQyvoUserInformationUpdateTrigger(false);
        }

        const getQyvoUserAddressData = async () => {
            try {
                const response = await fetch(
                    `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-qyvo-user-address-data/?qyvo_user_email=${QyvoUser?.qyvoUserEmail}`
                );
                if (response.ok) {
                    const responseData = await response.json();
                    setQyvoUserAddressData(responseData);
                }
            } catch (e) {
                console.log(e);
            }
        };

        getQyvoUserAddressData();

    }, [QyvoUser, QyvoUserInformationUpdateTrigger]);


    useEffect(() => {
        return () => {
            setQyvoUserData(null);
            setQyvoUserAddressData(null);
            setQyvoUserEditDataStatus(false);
            setRestApiRequestPendingStatus(false);
        };
    }, []);


    // const {
    //      qyvo_user_profile_image: userProfileImage,
    // } = QyvoUserData;

    const [qyvoUserProfileImageFile, setQyvoUserProfileImageFile] = useState<File | null>(null);

    const changeQyvoUserProfileImageFile = (e:React.ChangeEvent<HTMLInputElement>) => {

        if (!e.target.files || !e.target.files[0]) {
            return;
        }

        const file = e.target.files[0];
        const fileType = file.type;

        if (fileType !== "image/jpeg" && fileType !== "image/png") {
            return;
        }

        setQyvoUserProfileImage(URL.createObjectURL(file));
        setQyvoUserProfileImageFile(file);

        uploadProfileImageRequestHandler(file);

    };

    const uploadProfileImageRequestHandler = async (profileImageFile: File) => {

        const formData = new FormData();

        formData.append('qyvo_user_profile_picture_file', profileImageFile, profileImageFile.name);

        try {
            const response = await fetch(
                `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/${QyvoUser?.qyvoUserID}/update-user-profile-picture/`,
                {
                    method: 'PATCH', body: formData,
                }
            );
            if (response.ok) {
                setSystemCommunicateMessage('Changes Saved');
            } else {
                console.warn(response);
            }
        } catch (e) {
            console.log(e);
        }

    };


    const [qyvoUserProfileImage, setQyvoUserProfileImage] = useState('');

    const [qyvoUserFirstName, setQyvoUserFirstName] = useState('');
    const [qyvoUserFirstNameStatus, setQyvoUserFirstNameStatus] = useState<InputComponentStatusType | null>(null);
    const [qyvoUserLastName, setQyvoUserLastName] = useState('');
    const [qyvoUserLastNameStatus, setQyvoUserLastNameStatus] = useState<InputComponentStatusType | null>(null);
    const [qyvoUserEmailAddress, setQyvoUserEmailAddress] = useState('');
    const [qyvoUserEmailAddressStatus, setQyvoUserEmailAddressStatus] = useState<InputComponentStatusType | null>(null);

    const changeQyvoUserFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 2 && qyvoUserFirstNameStatus) {
            setQyvoUserFirstNameStatus({ type: 'success' });
        }
        setQyvoUserFirstName(value);
    };

    const changeQyvoUserLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 1 && qyvoUserLastNameStatus) {
            setQyvoUserLastNameStatus({ type: 'success' });
        }
        setQyvoUserLastName(value);
    };

    const changeQyvoUserEmailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (isEmail(qyvoUserEmailAddress) && qyvoUserEmailAddressStatus) {
            setQyvoUserEmailAddressStatus({ type: 'success' });
        }
        setQyvoUserEmailAddress(value);
    };

    useEffect(() => {

        if (!QyvoUserData) {
            return;
        }

        const {
            qyvo_user_first_name: qyvoUserFirstName, qyvo_user_last_name: qyvoUserLastName,
            qyvo_user_email: qyvoUserEmailAddress,
            qyvo_user_profile_picture: qyvoUserProfileImage
        } = QyvoUserData;

        setQyvoUserFirstName(qyvoUserFirstName);
        setQyvoUserLastName(qyvoUserLastName);
        setQyvoUserEmailAddress(qyvoUserEmailAddress);

        if (QyvoUserData.qyvo_user_profile_picture) {
            setQyvoUserProfileImage(
                `https://qyvo-engine.webpros.pl/${QyvoUserData.qyvo_user_profile_picture }`
            );
        }

    }, [QyvoUserData]);

    useEffect(() => {
        return () => {
            setQyvoUserFirstName('');
            setQyvoUserLastName('');
            setQyvoUserEmailAddress('');
        };
    }, []);

    const clearQyvoUserDataStatuses = () => {
        setQyvoUserFirstNameStatus(null);
        setQyvoUserLastNameStatus(null);
        setQyvoUserEmailAddressStatus(null);
    };


    const [qyvoUserAddressPhoneNumber, setQyvoUserAddressPhoneNumber] = useState('');
    const [qyvoUserAddressPhoneNumberStatus, setQyvoUserAddressPhoneNumberStatus] = useState<InputComponentStatusType | null>(null);

    const changeQyvoUserAddressPhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (isMobilePhone(value, isMobilePhoneLocales) && qyvoUserAddressPhoneNumberStatus) {
            setQyvoUserAddressPhoneNumberStatus({ type: 'success' });
        }
        setQyvoUserAddressPhoneNumber(value);
    };

    const [qyvoUserAddressStreet, setQyvoUserAddressStreet] = useState('');
    const [qyvoUserAddressStreetStatus, setQyvoUserAddressStreetStatus] = useState<InputComponentStatusType | null>(null);
    const [qyvoUserAddressHouseNo, setQyvoUserAddressHouseNo] = useState('');
    const [qyvoUserAddressHouseNoStatus, setQyvoUserAddressHouseNoStatus] = useState<InputComponentStatusType | null>(null);
    const [qyvoUserAddressPostalCode, setQyvoUserAddressPostalCode] = useState('');
    const [qyvoUserAddressPostalCodeStatus, setQyvoUserAddressPostalCodeStatus] = useState<InputComponentStatusType | null>(null);
    const [qyvoUserAddressCity, setQyvoUserAddressCity] = useState('');
    const [qyvoUserAddressCityStatus, setQyvoUserAddressCityStatus] = useState<InputComponentStatusType | null>(null);
    const [qyvoUserAddressCountry, setQyvoUserAddressCountry] = useState(0);
    const [qyvoUserAddressCountryStatus, setQyvoUserAddressCountryStatus] = useState<InputComponentStatusType | null>(null);

    useEffect(() => {

        if (!QyvoUserAddressData) {
            return;
        }

        const {
            qyvo_user_address_country: qyvoUserAddressCountry,
            qyvo_user_address_street: qyvoUserAddressStreet, qyvo_user_address_house_no: qyvoUserAddressHouseNo,
            qyvo_user_address_postal_code: qyvoUserAddressPostalCode, qyvo_user_address_city: qyvoUserAddressCity,
            qyvo_user_address_phone_number: qyvoUserAddressPhoneNumber
        } = QyvoUserAddressData

        setQyvoUserAddressCountry(qyvoUserAddressCountry ?? 0);
        setQyvoUserAddressStreet(qyvoUserAddressStreet ?? '');
        setQyvoUserAddressHouseNo(qyvoUserAddressHouseNo ?? '');
        setQyvoUserAddressPostalCode(qyvoUserAddressPostalCode ?? '');
        setQyvoUserAddressCity(qyvoUserAddressCity ?? '');
        setQyvoUserAddressPhoneNumber(qyvoUserAddressPhoneNumber ?? '');

    }, [QyvoUserAddressData]);

    const changeQyvoUserAddressStreet = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 4 && qyvoUserAddressStreetStatus) {
            setQyvoUserAddressStreetStatus({ type: 'success' });
        }
        setQyvoUserAddressStreet(value);
    };

    const changeQyvoUserAddressHouseNo = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 0 && qyvoUserAddressHouseNoStatus) {
            setQyvoUserAddressHouseNoStatus({ type: 'success' });
        }
        setQyvoUserAddressHouseNo(value);
    };

    const changeQyvoUserAddressPostalCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 5 && qyvoUserAddressPostalCodeStatus) {
            setQyvoUserAddressPostalCodeStatus({ type: 'success' });
        }
        setQyvoUserAddressPostalCode(value);
    };

    const changeQyvoUserAddressCity = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 2 && qyvoUserAddressCityStatus) {
            setQyvoUserAddressCityStatus({ type: 'success' });
        }
        setQyvoUserAddressCity(value);
    };

    const changeQyvoUserAddressCountry = (countryID: number = 0) => {
        setQyvoUserAddressCountry(countryID);
    };

    useEffect(() => {
        return () => {
            setQyvoUserAddressPhoneNumber('');
            setQyvoUserAddressStreet('');
            setQyvoUserAddressHouseNo('');
            setQyvoUserAddressPostalCode('');
            setQyvoUserAddressCity('');
            setQyvoUserAddressCountry(0);
            clearQyvoUserAddressDataStatuses();
        };
    }, []);

    const clearQyvoUserAddressDataStatuses = () => {
        setQyvoUserAddressPhoneNumberStatus(null);
        setQyvoUserAddressStreetStatus(null);
        setQyvoUserAddressHouseNoStatus(null);
        setQyvoUserAddressPostalCodeStatus(null);
        setQyvoUserAddressCityStatus(null);
        setQyvoUserAddressCountryStatus(null);
    };


    const QyvoUserEditDataSaveTrigger = () => {

        let fieldErrors = false;

        if (qyvoUserFirstName.length < 2) {
            fieldErrors = true;
            setQyvoUserFirstNameStatus({ type: 'error', message: 'Value is too short' });
        }

        if (qyvoUserLastName.length < 2) {
            fieldErrors = true;
            setQyvoUserLastNameStatus({ type: 'error', message: 'Value is too short' });
        }

        if (!isEmail(qyvoUserEmailAddress)) {
            fieldErrors = true;
            setQyvoUserEmailAddressStatus({ type: 'error', message: 'Email is not valid' });
        }

        if (!isMobilePhone(qyvoUserAddressPhoneNumber, isMobilePhoneLocales)) {
            fieldErrors = true;
            setQyvoUserAddressPhoneNumberStatus({ type: 'error', message: 'Phone Number is not valid' })
        }

        if (qyvoUserAddressStreet.length < 5) {
            fieldErrors = true;
            setQyvoUserAddressStreetStatus({ type: 'error', message: 'Street Name is too short' });
        }

        if (qyvoUserAddressHouseNo.length < 1) {
            fieldErrors = true;
            setQyvoUserAddressHouseNoStatus({ type: 'error', message: 'Value is too short' });
        }

        if (qyvoUserAddressPostalCode.length < 6) {
            fieldErrors = true;
            setQyvoUserAddressPostalCodeStatus({ type: 'error', message: 'Value is too short' });
        }

        if (qyvoUserAddressCity.length < 3) {
            fieldErrors = true;
            setQyvoUserAddressCityStatus({ type: 'error', message: 'Value is too short' });
        }

        if (fieldErrors) {
            return;
        }

        qyvoUserDataUpdateRequestHandler();

    };


    const qyvoUserDataUpdateRequestHandler = async () => {

        const formData = new FormData();

        formData.append('user_first_name', qyvoUserFirstName);
        formData.append('user_last_name', qyvoUserLastName);
        // formData.append('user_email', qyvoUserEmailAddress);

        formData.append('user_address_country_id', qyvoUserAddressCountry.toString())
        formData.append('user_address_street', qyvoUserAddressStreet);
        formData.append('user_address_house_no', qyvoUserAddressHouseNo);
        formData.append('user_address_postal_code', qyvoUserAddressPostalCode);
        formData.append('user_address_city', qyvoUserAddressCity);
        formData.append('user_address_phone_number', qyvoUserAddressPhoneNumber);

        setRestApiRequestPendingStatus(true);

        try {

            const response = await fetch(
                `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/${QyvoUser?.qyvoUserID || 0}/update-qyvo-user-data/`,
                {
                    method: 'POST', body: formData
                }
            );

            if (response.ok) {
                clearQyvoUserDataStatuses();
                clearQyvoUserAddressDataStatuses();
                setQyvoUserEditDataStatus(false);
                setSystemCommunicateMessage('Changes Saved');
                setRestApiRequestPendingStatus(false);
            }

        } catch (e) {
            console.log(e);
        }

    };


    const countryOptions = Countries.map((item, i ) => {
        return { optionID: item['id'], optionValue: item['en'] };
    });


    // const updateQyvoUserInformation = async (
    //     qyvoUserDataType: 'PERSONAL_DATA' | 'ADDRESS_DATA',
    //     qyvoUserDataFieldName: string,
    //     qyvoUserDataFieldUpdatedValue: string,
    // ) => {
    //
    //     const formData = new FormData();
    //     formData.append('qyvo_user_information_field_type', qyvoUserDataType);
    //     formData.append('qyvo_user_information_field_name', qyvoUserDataFieldName);
    //     formData.append('qyvo_user_information_field_updated_value', qyvoUserDataFieldUpdatedValue);
    //
    //     try {
    //          const response = await fetch(
    //              `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/${QyvoUser?.qyvoUserID}/update-qyvo-user-information/`,
    //              {
    //                  method: 'POST',
    //                  body: formData
    //              }
    //          );
    //          if (response.ok) {
    //              setQyvoUserInformationUpdateTrigger(true);
    //          }
    //     } catch (e) {
    //         console.error(e);
    //     }
    //
    // };

    const [qyvoUserOldPassword, setQyvoUserOldPassword] = useState('');
    const [qyvoUserNewPassword, setQyvoUserNewPassword] = useState('');
    const [qyvoUserNewPasswordRepeat, setQyvoUserNewPasswordRepeat] = useState('');

    useEffect(() => {
        return () => {
            setQyvoUserOldPassword('');
            setQyvoUserNewPassword('');
            setQyvoUserNewPasswordRepeat('');
        };
    }, []);


    return (
    <Container className={'user-dashboard-page-container'}>
        <Row className={'user-dashboard-page-container__content'}>

                {/*<UserDashboardPageUserMenu />*/}

                {/*<DefaultPopupComponent*/}
                {/*    popupHeaderText={'Change Password'}*/}
                {/*    popupButtonText={'Save'}*/}
                {/*>*/}
                {/*    <InputFieldComponent*/}
                {/*        inputFieldLabel={'Old password'} inputFieldRequiredStatus={true}*/}
                {/*        inputFieldType={'password'}*/}
                {/*        inputFieldValue={qyvoUserOldPassword} inputFieldValueHandler={() => undefined}*/}
                {/*    />*/}
                {/*    <InputFieldComponent*/}
                {/*        inputFieldLabel={'New Password'} inputFieldRequiredStatus={true}*/}
                {/*        inputFieldType={'password'}*/}
                {/*        inputFieldValue={qyvoUserNewPassword} inputFieldValueHandler={() => undefined}*/}
                {/*    />*/}
                {/*    <InputFieldComponent*/}
                {/*        inputFieldLabel={'New password repeat'} inputFieldRequiredStatus={true}*/}
                {/*        inputFieldType={'password'}*/}
                {/*        inputFieldValue={qyvoUserNewPasswordRepeat} inputFieldValueHandler={() => undefined}*/}
                {/*    />*/}
                {/*</DefaultPopupComponent>*/}

                <UserDashboardUserMenuComponent />

                {restApiRequestPendingStatus &&
                <ApiRequestLoaderElementComponent />
                }

                {systemCommunicateMessage &&
                <SystemCommunicateElementComponent
                    communicateType={'success'}
                    communicateText={systemCommunicateMessage}
                    communicateCloseCallback={() => setSystemCommunicateMessage('')}
                />
                }

                <UserDashboardPageContent
                    headingText={'Profile'}
                    descriptionText={'Manage your account settings and preferences'}
                >

                    <UserDashboardPageContentSection
                        sectionName={'user-information'}
                    >

                        <Col xs={12} lg={4} className={'user-profile-avatar-section'}>
                            <Row className={'user-profile-avatar-section__content'}>
                                <Col xs={5} className={'user-profile-avatar-section__avatar-picture'}>
                                    <img src={qyvoUserProfileImage} alt={''} />
                                    <label htmlFor={'qyvo-user-profile-image-switcher'}>
                                        <SvgIconComponent
                                            iconSource={IconPhotoS}
                                            className={'user-profile-avatar-section__avatar-picture__change-avatar-button'}
                                        />
                                        <input
                                            type={'file'} id={'qyvo-user-profile-image-switcher'}
                                            accept="image/jpeg,image/png,image/gif"
                                            style={{ display: 'none' }}
                                            onChange={(e) => changeQyvoUserProfileImageFile(e)}
                                        />
                                    </label>
                                </Col>
                                <Col xs={7} className={'user-profile-avatar-section__user-information'}>
                                    <span className={'user-profile-avatar-section__user-information__user-name'}>{QyvoUserData?.qyvo_user_first_name} {QyvoUserData?.qyvo_user_last_name}</span>
                                    <span className={'user-profile-avatar-section__user-information__user-email'}>{QyvoUser?.qyvoUserEmail}</span>
                                    {/*<BadgeElementComponent*/}
                                    {/*    badgeType={'success'} badgeSize={'md'}*/}
                                    {/*    badgeText={'Premium member'}*/}
                                    {/*/>*/}
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} lg={{span: 7, offset: 1}} className={'user-profile-cta-section'}>
                            <Row className={'user-profile-cta-section__content'}>
                                <Col xs={12} className={'user-profile-cta-section__cta-buttons'}>
                                    <ButtonComponent
                                        text={'Change password'}
                                        type={'flat'} bordered={true} iconLeft={IconKeyS}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={QyvoUserEditDataStatus ? 'Cancel' : 'Edit profile'}
                                        iconLeft={IconEditS}
                                        callback={() => setQyvoUserEditDataStatus(!QyvoUserEditDataStatus)}
                                        // buttonDisabled={true}
                                    />
                                </Col>
                                <Col xs={12} className={'user-profile-cta-section__user-information'}>
                                    {QyvoUserData && <span>Member since: {dateFormat(QyvoUserData?.qyvo_user_registration_date, 'mmmm yyyy')}</span>}
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-refunds'}
                    >

                        <DashboardInformationCardElementComponent
                            cardIcon={IconDollarS}
                            cardHeaderText={'Total Refunds'}
                            cardContentText={'$0'}
                            // cardContentText={'$2,847'}
                        />

                        <DashboardInformationCardElementComponent
                            cardIcon={IconChartS}
                            cardHeaderText={'Active Claims'}
                            cardContentText={'0'}
                            // cardContentText={'12'}
                        />

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-personal-data'}
                        sectionHeaderText={'Personal information'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <InputComponent
                                    value={qyvoUserFirstName} setValue={(e) => changeQyvoUserFirstName(e)}
                                    label={'First name'}
                                    cssClasses={['user-first-name-field']}
                                    status={qyvoUserFirstNameStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <InputComponent
                                    value={qyvoUserLastName} setValue={(e) => changeQyvoUserLastName(e)}
                                    label={'Last name'}
                                    cssClasses={['user-last-name-field']}
                                    status={qyvoUserLastNameStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <InputComponent
                                    value={qyvoUserEmailAddress} setValue={(e) => changeQyvoUserEmailAddress(e)}
                                    label={'Email Address'}
                                    cssClasses={['user-email-address-field']}
                                    status={qyvoUserEmailAddressStatus}
                                    required={true} disabled={true}
                                    // disabled={!QyvoUserEditDataStatus}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Email Address secondary (optional)'}
                                    cssClasses={['user-secondary-email-address-field']}
                                    disabled={true}
                                />

                                <InputComponent
                                    type={'phone'}
                                    value={qyvoUserAddressPhoneNumber} setValue={(e) => changeQyvoUserAddressPhoneNumber(e)}
                                    label={'Phone Number'}
                                    cssClasses={['user-phone-number-field']}
                                    status={qyvoUserAddressPhoneNumberStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <Col xs={12} className={'user-dashboard-form-component__submit-form'}>
                                    <ButtonComponent
                                        text={'Save changes'}
                                        type={'primary'} size={'l'}
                                        callback={() => QyvoUserEditDataSaveTrigger()}
                                        buttonDisabled={!QyvoUserEditDataStatus}
                                    />
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-address-data'}
                        sectionHeaderText={'Address information'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <InputComponent
                                    value={qyvoUserAddressStreet} setValue={(e) => changeQyvoUserAddressStreet(e)}
                                    label={'Street Address'}
                                    cssClasses={['user-address-street-field']}
                                    status={qyvoUserAddressStreetStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <InputComponent
                                    value={qyvoUserAddressHouseNo} setValue={(e) => changeQyvoUserAddressHouseNo(e)}
                                    label={'Apt., suite, etc'}
                                    cssClasses={['user-address-apartment-number-field']}
                                    status={qyvoUserAddressHouseNoStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <InputComponent
                                    value={qyvoUserAddressPostalCode} setValue={(e) => changeQyvoUserAddressPostalCode(e)}
                                    label={'Zip / postcode'}
                                    cssClasses={['user-address-postcode-field']}
                                    status={qyvoUserAddressPostalCodeStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <InputComponent
                                    value={qyvoUserAddressCity} setValue={(e) => changeQyvoUserAddressCity(e)}
                                    label={'City'}
                                    cssClasses={['user-address-city-field']}
                                    status={qyvoUserAddressCityStatus}
                                    required={true} disabled={!QyvoUserEditDataStatus}
                                />

                                <FormDropdownComponent
                                    fieldOptions={countryOptions}
                                    fieldLabelText={'Country'}
                                    selectedOptionID={qyvoUserAddressCountry}
                                    optionChoiceHandler={changeQyvoUserAddressCountry}
                                    fieldRequiredStatus={true}
                                    fieldDisabledStatus={!QyvoUserEditDataStatus}
                                    // fieldDisabledStatus={true}
                               />

                                <Col xs={12} className={'user-dashboard-form-component__submit-form'}>
                                    <ButtonComponent
                                        text={'Save changes'}
                                        type={'primary'} size={'l'}
                                        callback={() => QyvoUserEditDataSaveTrigger()}
                                        buttonDisabled={!QyvoUserEditDataStatus}
                                    />
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-preferences'}
                        sectionHeaderText={'Preferences'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'} style={{ opacity: 0.6 }}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <Col xs={12} className={'switcher-field-component'}>
                                    <Row className={'switcher-field-component__content'}>
                                        <Col xs={9} lg={10} className={'switcher-field-component__field-texts'}>
                                            <Row className={'switcher-field-component__field-texts__content'}>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-name'}>
                                                    <span>Email Notifications</span>
                                                </Col>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-description'}>
                                                    <span>Receive updates about your claims</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={3} lg={2} className={'switcher-field-component__field-switcher'}>
                                            <Form.Check type={'switch'} disabled={true} onChange={QyvoUserEditDataSaveTrigger} />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'switcher-field-component'}>
                                    <Row className={'switcher-field-component__content'}>
                                        <Col xs={9} lg={10} className={'switcher-field-component__field-texts'}>
                                            <Row className={'switcher-field-component__field-texts__content'}>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-name'}>
                                                    <span>SMS Notifications</span>
                                                </Col>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-description'}>
                                                    <span>Get text updates for urgent matters</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={3} lg={2} className={'switcher-field-component__field-switcher'}>
                                            <Form.Check type={'switch'} disabled={true} onChange={QyvoUserEditDataSaveTrigger} />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'switcher-field-component'} >
                                    <Row className={'switcher-field-component__content'}>
                                        <Col xs={9} lg={10} className={'switcher-field-component__field-texts'}>
                                            <Row className={'switcher-field-component__field-texts__content'}>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-name'}>
                                                    <span>Dark Mode</span>
                                                </Col>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-description'}>
                                                    <span>Switch to dark theme</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={3} lg={2} className={'switcher-field-component__field-switcher'}>
                                            <Form.Check type={'switch'} disabled={true} onChange={QyvoUserEditDataSaveTrigger} />
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-billing-data'}
                        sectionHeaderText={'Billing'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                {/*<Col xs={12} className={'message-element-component'}>*/}
                                {/*    <span>No Apps connected</span>*/}
                                {/*</Col>*/}

                                <Col xs={12} className={'dashboard-option-card-component'} style={{ opacity: 0.7 }}>
                                    <Row className={'dashboard-option-card-component__content'}>
                                        <Col xs={3} xl={1} className={'dashboard-option-card-icon'}>
                                            <SvgIconComponent iconSource={paypallIcon} />
                                        </Col>
                                        <Col xs={9} xl={6} className={'dashboard-option-card-data'}>
                                            <Row className={'dashboard-option-card-data__content'}>
                                                <Col xs={12} className={'dashboard-option-card-data__card-title'}>
                                                    <span>PayPal</span>
                                                </Col>
                                                <Col xs={12} className={'dashboard-option-card-data__card-description'}>
                                                    <span>Payment processing <span style={{ color: '#045482' }}>(option inactive - for demo purpose)</span></span>
                                                </Col>
                                                <Col xs={12} className={'dashboard-option-card-data__card-information'}>
                                                    <span className={'option-data-status'}>
                                                        <span>Connected</span>
                                                    </span>
                                                    <span className={'option-data-text'}>Connected 3 months ago</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} xl={5} className={'dashboard-option-card-options'}>
                                            <Row className={'dashboard-option-card-options__content'}>
                                                <ButtonComponent
                                                    text={'Update'}
                                                    type={'flat'}
                                                    size={'l'}
                                                    buttonDisabled={true}
                                                />
                                                <ButtonComponent
                                                    text={'Remove'}
                                                    type={'secondary'}
                                                    size={'l'}
                                                    buttonDisabled={true}
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                                {/*<Col xs={12} className={'dashboard-option-card-component'}>*/}
                                {/*    <Row className={'dashboard-option-card-component__content'}>*/}
                                {/*        <Col xs={3} xl={1} className={'dashboard-option-card-icon'}>*/}
                                {/*            <SvgIconComponent iconSource={bankIcon} />*/}
                                {/*        </Col>*/}
                                {/*        <Col xs={9} xl={6} className={'dashboard-option-card-data'}>*/}
                                {/*            <Row className={'dashboard-option-card-data__content'}>*/}
                                {/*                <Col xs={12} className={'dashboard-option-card-data__card-title'}>*/}
                                {/*                    <span>Chase Bank</span>*/}
                                {/*                </Col>*/}
                                {/*                <Col xs={12} className={'dashboard-option-card-data__card-description'}>*/}
                                {/*                    <span>Account ending in ****4567</span>*/}
                                {/*                </Col>*/}
                                {/*                <Col xs={12} className={'dashboard-option-card-data__card-information'}>*/}
                                {/*                    <span className={'option-data-status'}>*/}
                                {/*                        <span>Connected</span>*/}
                                {/*                    </span>*/}
                                {/*                    <span className={'option-data-text'}>Last verified: 1 week ago</span>*/}
                                {/*                </Col>*/}
                                {/*            </Row>*/}
                                {/*        </Col>*/}
                                {/*        <Col xs={12} xl={5} className={'dashboard-option-card-options'}>*/}
                                {/*            <Row className={'dashboard-option-card-options__content'}>*/}
                                {/*                <ButtonComponent*/}
                                {/*                    text={'Manage'}*/}
                                {/*                    type={'flat'}*/}
                                {/*                    size={'l'}*/}
                                {/*                    buttonDisabled={true}*/}
                                {/*                />*/}
                                {/*                <ButtonComponent*/}
                                {/*                    text={'Disconnect'}*/}
                                {/*                    type={'secondary'}*/}
                                {/*                    size={'l'}*/}
                                {/*                    buttonDisabled={true}*/}
                                {/*                />*/}
                                {/*            </Row>*/}
                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*</Col>*/}

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'delete-account'}
                    >

                        <Col xs={9} className={'delete-account-heading-text'} style={{ opacity: 0.7 }}>
                            <span>Delete account</span>
                        </Col>

                        <Col xs={3} className={'delete-account-submit-button'} style={{ opacity: 0.5 }}>
                            <ButtonComponent text={'Delete'} type={'flat'} buttonDisabled={true} />
                        </Col>

                    </UserDashboardPageContentSection>

                </UserDashboardPageContent>
        </Row>
        </Container>
    );

};


export default UserDashboardProfilePage;
